module.exports = __webpack_public_path__ + "img/mastercard-visa-secure.50cd3c2c.png";